import z from 'zod';

import { JournalDtoScheme } from '~modules/journal/model';
import { EmployeeSchedulePlanDtoScheme } from '~modules/schedule/dto';
import { SectionDtoScheme } from '~modules/section/model';
import { StaffingDtoScheme } from '~modules/staffing/dto';
import { UserDtoScheme } from '~modules/user/model';

import { WorkTimeTypes } from '../interfaces/work-time-types';
import { DeviationDtoScheme } from './deviation.dto';
import { TabelRowBaseDtoScheme } from './tabel-row-base.dto';

export const TabelRowDtoScheme = TabelRowBaseDtoScheme.extend({
	user: UserDtoScheme.describe('Сотрудник').nullable().optional(),
	responsible: UserDtoScheme.describe('Ответственный').nullable().optional(),
	checkin_start: JournalDtoScheme.describe('Начало работы').nullable().optional(),
	checkin_end: JournalDtoScheme.describe('Окончание работы').nullable().optional(),
	section: SectionDtoScheme.describe('Участок').nullable().optional(),
	employee_schedule_plan: EmployeeSchedulePlanDtoScheme.describe('План график').nullable().optional(),
	staffing: StaffingDtoScheme.describe('Штатка').nullable().optional(),
	work_time_type: z.nativeEnum(WorkTimeTypes).nullable().describe('Вид рабочего времени'),
	deviation: DeviationDtoScheme.describe('Отклонение').nullable(),
});

export type TabelRowDto = z.infer<typeof TabelRowDtoScheme>;
